<template>
  <div class="bg-panel p-1 px-2 flex items-center text-sm cursor-default">
    <div class="bg-teal-600 text-white px-4 rounded-tr-full rounded-bl-full flex items-center">
      <MousePointerIcon size="12" class="mr-1" />
      <div>templyfy</div>
    </div>
    <div class="flex-grow flex">
      <div
        class="pl-2 flex items-center"
        :class="selected === 'create' ? 'text-gray-200' : 'text-gray-600'"
        @click="()=> this.$router.push('create')"
      >
        <PenToolIcon size="16" class="mr-1" />
        <div>Create</div>
      </div>

      <div
        :class="selected === 'preview' ? 'text-gray-200' : 'text-gray-600'"
        class="pl-2 flex items-center"
        @click="()=> this.$router.push('preview')"
      >
        <EyeIcon size="16" class="mr-1" />
        <div>Preview</div>
      </div>
      <div
        :class="selected === 'custom' ? 'text-gray-200' : 'text-gray-600'"
        class="pl-2 flex items-center flex-grow"
        @click="()=> this.$router.push('custom')"
      >
        <CoffeeIcon size="16" class="mr-1" />
        <div>Custom</div>
      </div>
      <div
        :class="selected === 'marketplace' ? 'text-gray-200' : 'text-gray-600'"
        class="pr-2 flex items-center"
        @click="()=> this.$router.push('marketplace')"
      >
        <ShoppingBagIcon size="16" class="mr-1" />
        <div>Market Place</div>
      </div>
    </div>
    <div class="p-1 pr-2 text-white hover:text-white r text-xs rounded-full">
      <div @click="loginWithGoogle()" v-if="!user" class="flex items-center">
        <!-- <UserIcon size="16" /> -->
        <div class="bg-white rounded-full h-4 w-4 flex justify-center">
          <img src="@/assets/google.png" class="h-4 m-auto" />
        </div>
        <div class="ml-1">Sign with Google</div>
      </div>
      <div v-else class="flex items-center">
        <div class="rounded-full h-4 w-4 flex justify-center items-center">
          <UserIcon size="16" />
        </div>
        <div class="ml-1">{{user.user.displayName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Header",
  props: {
    selected: { default: "create" }
  },

  mounted() {
    this.loadUser();
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["loginWithGoogle", "loadUser"]),
    addNew() {
      if (
        !this.components.length ||
        !this.components.find(item => item.data().name === this.name)
      ) {
        const el = document.createElement("div");
        el.setAttribute("class", "h-full bg-gray-100 p-2");
        this.rootNode.appendChild(el);
        this.selectNode(this.rootNode.children[0]);
        this.addComponent(this.name);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
